import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OtherApiService } from 'src/app/Services/other.service';

@Component({
  selector: 'app-future-date-dialog',
  templateUrl: './future-date-dialog.component.html',
  styleUrls: ['./future-date-dialog.component.scss']
})
export class FutureDateDialogComponent implements OnInit {
  primaryColour: string = '#5867dd';

  constructor(
    public dialogRef: MatDialogRef<FutureDateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { date: any; formattedDate: string },
    private apiService: OtherApiService
  ) {}

  ngOnInit() {
    try {
      this.primaryColour = this.apiService.passColour() || '#5867dd';
    } catch (e) {
      this.primaryColour = '#5867dd';
    }
  }

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
